import URI from 'jsuri';
import Cookies from 'js-cookie';

export function existAndRun(fn, ...args) {
    if (fn) {
        fn(...args);
    }
}

export function noop() {
    return void 0;
}

export default {
    waitTimeout(time = 0) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    },
    /**
     * 默认添加 query 参数 v 时间戳强制刷新页面。如有 code 则无需带 v
     * 因为 reload 有些环境没有刷新，可以使用 href 带版本号强制刷新，但 location.href 会产生历史记录（返回读缓存的场景页面状态没更新），所以使用 replaceState + reload 处理
     */
    enforceRefresh(queryObj = {v: new Date().getTime()}) {
        let newUrl = window.location.href;
        Object.keys(queryObj).forEach(key => {
            newUrl = new URI(newUrl).replaceQueryParam(key, queryObj[key]).toString();
        });
        window.history.replaceState(null, document.title, newUrl);
        window.location.reload();
    },
    // 分享统计
    countShare(type, ztID) {
        type = type || '';
        if (type == 1) {
            type = 'friend';
        } else if (type == 2) {
            type = 'cirfriend';
        } else if (type == 3) {
            type = 'sinaweibo';
        } else if (type == 4) {
            type = 'qqzone';
        } else if (type == 5) {
            type = 'tencentweibo';
        } else if (type == 6) {
            type = 'qq';
        } else {
            type = '';
        }
        if (ztID) {
            const _img = new Image();
            _img.src = `//act.mama.cn/home/v6/share/index/count?parse=${type}&zt_id=${ztID}&callback=`;
        }
    },
    formatURL(url) {
        const regProtocol = /^http:|https:/;
        const regBase64 = /data:\w+\/\S+;base64,/;
        if ((url && regProtocol.test(url)) || regBase64.test(url)) {
            return url;
        } else if (url) {
            return window.location.protocol ? `${window.location.protocol}${url}` : url;
        } else {
            return '';
        }
    },
    comparisonDomain(domain) {
        const hostnameWord = window.location.hostname.split('.').reverse();
        const domainWord = domain.split('.').reverse();
        let flag = true;
        if (hostnameWord.length >= domainWord.length) {
            hostnameWord.forEach(function (item, i) {
                domainWord[i] && item !== domainWord[i] && (flag = false);
            });
        } else {
            flag = false;
        }
        return flag;
    },
    fixCookie(cookieData) {
        // webview 种 cookie 延迟（登录相关的 cookie），由 app 返回前端种入
        if (cookieData && cookieData.length) {
            cookieData.forEach(item => {
                if (item.conf && item.name && item.value && item.conf.domain && item.conf.expires) {
                    // 判断是否当前域的 cookie（实际跨域也 set 不进）
                    const matching = this.comparisonDomain(item.conf.domain);
                    // 只针对没有的情况，不重写已存在的
                    const hasCurrentCookie = Cookies.get(item.name);
                    if (matching && !hasCurrentCookie) {
                        try {
                            item.conf.expires = parseInt(
                                (new Date(parseInt(item.conf.expires) * 1000).getTime() - new Date().getTime()) /
                                    1000 /
                                    60 /
                                    60 /
                                    24
                            );
                            item.conf.expires = item.conf.expires < 1 ? 1 : item.conf.expires;
                            Cookies.set(item.name, item.value, item.conf);
                        } catch (err) {
                            console.error(err.message);
                        }
                    }
                }
            });
        }
    },
    // 检查是否在小程序环境
    checkMiniProgram() {
        return window.__wxjs_environment === 'miniprogram';
    },
    debug(msg = 'fail') {
        // window.alert(msg);
        console.error(msg);
    },

    extend(targetObject, sourceObject) {
        for (const key in sourceObject) {
            if (key in targetObject) {
                throw new Error(`${key} 字段已存在`);
            }
            targetObject[key] = sourceObject[key];
        }
        return targetObject;
    },
    /**
     * 将 url 字符串参数替换为新的 key value 值
     * @param url
     * @param obj
     * @returns {*}
     */
    replaceQueryParam(url = '', obj) {
        let newUrl = url;
        if (obj && Object.prototype.toString.call(obj) === '[object Object]') {
            Object.keys(obj).forEach(key => {
                newUrl = new URI(newUrl).replaceQueryParam(key, obj[key]).toString();
            });
            return newUrl;
        } else {
            return url;
        }
    },
    goBack() {
        if (window.history.length <= 1) {
            // window.history.length 大于 1 不一定就代表还有历史记录，也可能是最后一页
            // document.referrer 也无法判断是否最后页面，因为单页 hash 之前跳转没有 referrer
            if (window.MJSSDK.UA.mamaApp) {
                window.MJSSDK.closeWindow();
            } else if (window.MJSSDK.UA.wx) {
                window.WeixinJSBridge && window.WeixinJSBridge.call('closeWindow');
            } else {
                window.opener = null;
                window.open('', '_self');
                window.close();
                window.history.back();
                window.location.href = 'about:blank ';
            }
        } else {
            window.history.back();
        }
    }
};
